import { Trans } from '@gamiphy/react-i18n';
import {
  Box, Button, Grid, Typography,
} from '@mui/material';
import {
  useTheme,
} from '@mui/material/styles';
import { observer } from 'mobx-react';
import React from 'react';
import { formatCurrencyNumber } from '@gamiphy/utils/number';
import Color from 'color';
import { fullMonthFormatDate } from '@gamiphy/utils/date';
import { UiStore } from '@gamiphy/loyalty-station-desktop/store/ui';
import { DiscountDto } from '@coretava/api/ecommerce-service';
import { Discount } from '@gamiphy/bl/reward';
import { AppStore } from '@gamiphy/loyalty-station-desktop/store/app';
import Money from '../assets/Money';
import Calendar from '../assets/Calendar';
import { getButtonGradiant } from '../utils';

const DiscountDetails: React.FC<{ discount: DiscountDto, appDiscount: Discount, btnFontSize?: string }> = ({ discount, appDiscount, btnFontSize }) => {
  const theme = useTheme();

  return (
    <Grid container spacing={2}>
      <Grid size={12}>
        <Typography fontSize={14} mb={0.5} textTransform="capitalize">
          <Trans
            i18nKey="redeem.discountCodeApplied.checkGiftCard"
            defaults="Check Your {{, discountType}} Below"
            values={{}}
          />
        </Typography>
        <Typography color="primary" fontWeight={600} fontSize={14}>
          <Trans
            i18nKey="redeem.discountCodeApplied.automaticallyUsed"
            defaults="It will be automatically used on your next order"
          />
        </Typography>
      </Grid>
      <Grid size={12}>
        <Box
          bgcolor={Color(theme.palette.primary.main).lighten(0.97).hex()}
          color="primary.main"
          textAlign="center"
          border={(th) => `1px dashed ${th.palette.primary.main}`}
          p={2.5}
          borderRadius={1.2}
          fontSize={28}
          fontWeight={800}
        >
          {formatCurrencyNumber(discount.value)}
        </Box>
      </Grid>
      <Grid size={12}>
        {appDiscount.minimumOrderValue && (
        <Box display="flex" alignItems="center" gap={1} mb={1}>
          <Money color={theme.palette.primary.main} />
          <Typography component="span" fontSize={14}>
            <Trans
              i18nKey="redeem.discountCodeApplied.minimum"
              defaults="Minimum {{minimum, currency}}"
              values={{
                minimum: appDiscount.minimumOrderValue,
              }}
            />
          </Typography>
        </Box>
        )}
        {discount.expiresAt && (
        <Box display="flex" alignItems="center" gap={1}>
          <Calendar color={theme.palette.primary.main} />
          <Typography component="span" fontSize={14}>
            <Trans
              i18nKey="redeem.discountCodeApplied.validity"
              defaults="Valid until {{date}}"
              values={{
                date: fullMonthFormatDate(discount.expiresAt),
              }}
            />
          </Typography>
        </Box>
        )}
      </Grid>
      {AppStore.app.agent === 'vtex' && (
        <Grid size={12}>
          <Button
            variant="contained"
            fullWidth
            onClick={() => UiStore.openCheckoutExample()}
            sx={{
              p: 1.25,
              borderRadius: '100px',
              fontSize: btnFontSize,
              background: (th) => getButtonGradiant(th.palette.primary.main),
            }}
          >
            <Trans
              i18nKey="redeem.discountCodeApplied.howItWorks"
              defaults="See how it works In Checkout"
            />
          </Button>
        </Grid>
      )}
    </Grid>
  );
};

export default observer(DiscountDetails);
